'use client';

import { ComponentProps, useRef } from 'react';
import PhoneInput, { Country, Value } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import CountrySelect from '@/hotdesk-ui/components/shared/CountrySelect';
import { useDefaultPhoneCountry } from '@/hotdesk-ui/hooks/useDefaultPhoneCountry';
import { usePhoneLabels } from '@/hotdesk-ui/lib/phone-labels';
type AppPhoneInputProps = Omit<ComponentProps<typeof PhoneInput>, 'labels' | 'countrySelectComponent' | 'onChange'> & {
  defaultCountry?: Country;
  onChange?: (value?: Value) => void;
};
function AppPhoneInput({
  defaultCountry: defaultCountryProp,
  value,
  onChange,
  ...props
}: AppPhoneInputProps) {
  const labels = usePhoneLabels();
  const geoCountry = useDefaultPhoneCountry();
  const resolvedCountry = defaultCountryProp ?? geoCountry;
  const inputKeyRef = useRef(`phone-${resolvedCountry}`);
  if (!value) {
    inputKeyRef.current = `phone-${resolvedCountry}`;
  }
  return <PhoneInput key={inputKeyRef.current} {...props}
  // CountrySelect already shows the dial code beside the flag.
  // Force national format so "+20" (etc.) is not duplicated in the input.
  international={false} countryCallingCodeEditable={false} onChange={value => onChange?.(value)} value={value as Value | undefined} defaultCountry={resolvedCountry} labels={labels} countrySelectComponent={CountrySelect} data-sentry-element="PhoneInput" data-sentry-component="AppPhoneInput" data-sentry-source-file="AppPhoneInput.tsx" />;
}
export default AppPhoneInput;